import Vue from 'vue'
import VueCompositionAPI, { watch } from '@vue/composition-api'
import App from './src/Widget'
import '@/libs/vue-select'

// Settings
import settingsModule from '@/helpers/settings.module'
import store from './src/store'

Vue.use(settingsModule)

require('@core/scss/widget.scss')

Vue.use(VueCompositionAPI)
const { setWidgetSettingsToStore, setWidgetSettings } = settingsModule()
setWidgetSettingsToStore()
const app = new Vue({
  data: {
    isDisplayedPoints: false,
    isDisplayedBeneficiary: false,
    useOldTicketGenerationType: false,
  },
  methods: {
    updateDisplayedPoints(isDisplayed) {
      this.isDisplayedPoints = isDisplayed
    },
    updateDisplayedBeneficiary(isDisplayed) {
      this.isDisplayedBeneficiary = isDisplayed
    },
    updateUseOldTicketGenerationType(useOldTicketGenerationType) {
      this.useOldTicketGenerationType = useOldTicketGenerationType
    },
  },
  render: h => h(App, {
    props: {
      eventId: +document.querySelector('#app').dataset.eventId,
      tPromo: new URL(document.location).searchParams.get('tpromo'),
      // eslint-disable-next-line radix
      maxTicketsBuy: parseInt(process.env.MIX_WIDGET_MAX_TICKETS_BUY) || 15,
    },
  }),
}).$mount('#app')
watch(() => store.state.app.settings, () => {
// Displayed points and beneficiary
  setWidgetSettings(app)
})
